import React, { FC } from 'react';

import styles from './index.module.sass';

interface HeaderProps {
  discountLabel: string;
}

const Header: FC<HeaderProps> = ({ discountLabel }) => (
  <>
    <h1 className={styles.headline}>Get { discountLabel } Off Your First Order</h1>

    <p className={styles.text}>
      Join our list to be the first to hear about our limited drops, exclusive sales and brand
      collabs sent directly to you.
    </p>
  </>
);

export default Header;
